import { Subject } from 'rxjs';

export const OPEN_DIALOG = 'OPEN_DIALOG';

export enum ThreadFilterEventType {
    apply = 'APPLY',
    suspend = 'SUSPEND',
}

export class ThreadFilterConfig {
    keyInStore?: string;

    filterItemsSelector: any;
    filterStatusSelector: any;
    filterLogicSelector: any;

    setFilterLogicAction: any;
    setFilterItemsAction: any;
    addFilterItemAction: any;
    setFilterEnableAction: any;

    actionSubject$: Subject<any>;
    eventSubject$: Subject<any>;

    constructor() {
        this.eventSubject$ = new Subject<any>();
        this.actionSubject$ = new Subject<any>();
    }
}
